import React, { createContext, useContext, useEffect, useState } from 'react';
import { PassengerAPI } from '../../../../../API/PassengerAPIs/PassengerAPIs';
import ViewPassenger from './ViewPassenger/ViewPassenger';
import { useNavigate, useParams } from 'react-router-dom';
import './PassengersHome.css';
import PassengerForm from './PassengerForm/PassengerForm';
import STC from '../../../../../STCLibrary/STCFactory/STCFactory';
import ColouredLoadingSymbol from '../../../../../STCLibrary/LoadingAnimation/ColouredLoadingSymbol/ColouredLoadingSymbol';
import NotificationContext from '../../../../../STCLibrary/NotificationSystem/NotificationContext';
import ApiResponseHandler from '../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';

export const PassengersContext = createContext();

function PassengersHome() {

    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const urlParams = useParams()
    const [loading, setLoading] = useState(true);
    const [addPassenger, setAddPassenger] = useState(false);
    const [passengerData, setPassengerData] = useState([]);
    
    const getPassengers = () => {
        PassengerAPI.GetPortalPassengers(urlParams.userID)
            .then((response) => {
                if (response.status === 200) {
                    const arr = response.data;
                    setPassengerData([...arr].sort((a, b) => b.id - a.id));
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
                ApiResponseHandler(err.response, notificationCtx, navigate);
            })
    };

    const handleSuccess = () => {
        setAddPassenger(false);
        setLoading(true);
        getPassengers();
    }

    useEffect(() => {
        getPassengers();
    }, []);

    if(loading){
        return(<div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}>
            <ColouredLoadingSymbol  />
          </div>)
    }
    else{
        return (
           <PassengersContext.Provider value={getPassengers}>
            <div  className={'passenger-home-container h-100'}>
                <div> 
                    <div style={{width: '100%', display: 'flex', alignItems:'center', justifyContent: 'center',marginBottom:'15px'}}>
                        {addPassenger ? 
                        <STC.Button   size='sm' onClick={() => setAddPassenger(false)}>Cancel the process </STC.Button>
                        :
                        <div style={{maxWidth: '650px'}}>
                            <STC.Button style={{width: '100%'}} onClick={() => setAddPassenger(true)}>Add a new passenger!</STC.Button>
                        </div>
                        }
                    </div>
                </div>

                {addPassenger ? 
                <div className="view-passengers">
                    <div className="view-passenger-container">
                    <div className='view-passenger-card'><PassengerForm handleSuccess={handleSuccess}/></div>   
                    </div> 
                </div>
                :
                <div className="view-passengers">
                {passengerData.map((passenger) => (
                    <div key={passenger.id} className="view-passenger-container">
                    <ViewPassenger  passenger={passenger}/>
                    </div>
                ))}
                </div>
    }
            </div>
            </PassengersContext.Provider>
        );
    }
}       
export default PassengersHome;
